import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const SUPPORT_PERMISSIONS = { WRITE: PERMISSIONS.SUPPORT_WRITE };
export const SUPPORT_QUERY_KEYS = queryKeys.support;
export const TICKET_STATUSES = ['OPEN', 'IN_PROGRESS', 'RESOLVED', 'CLOSED'];
export const TICKET_PRIORITIES = ['LOW', 'MEDIUM', 'HIGH'];
export const TICKET_PORTALS = ['BUYER', 'SUPPLIER', 'ADMIN'];
export const TICKET_CHANNELS = ['TICKET', 'CHAT'];
export const FAQ_PORTALS = ['BUYER', 'SUPPLIER', 'ALL'];
export const FAQ_CATEGORIES = ['CONTRACTS', 'PAYMENTS', 'DELIVERY', 'INVOICES', 'PRODUCTS', 'DISPUTES', 'GENERAL'];
export const VIDEO_PORTALS = ['BUYER', 'SUPPLIER'];
